<template>
  <div class="featured-section-v2-container">
    <template v-if="sectionList.length">
      <div class="featured-section-v2">
        <div
          v-for="(section, sIndex) in sectionList"
          :key="sIndex"
          class="featured-section-v2__card"
        >
          <div
            class="featured-section-v2__image"
            @click.stop="(e) => goLink(e, section.LinkUrl)"
          >
            <a
              class="featured-section-v2__link"
            >
              <img
                :src="section.IconUrl"
                :alt="section.Title"
              >
            </a>
          </div>
          <div class="featured-section-v2__content">
            <h3 class="featured-section-v2__title">
              {{ section.Title }}
            </h3>
          </div>
        </div>
      </div>
      <div
        v-if="sectionList.length"
        class="scrollbar-container"
      >
        <div class="scrollbar-container__thumb" />
      </div>
    </template>
    <!-- Loading -->
    <template v-else>
      <div class="loading-container">
        <div
          v-for="i in 8"
          :key="i"
          class="loading-container__grid"
        >
          <v-skeleton-loader type="card" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { handleLinkNavigation } from '@/utils/navigation.js'

export default {
  props: {
    sectionList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    sectionList: {
      handler (newVal) {
        if (newVal && newVal.length) {
          this.$nextTick(() => {
            this.initScrollListener()
            this.updateScrollbar()
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  beforeDestroy () {
    const scrollContainer = this.$el && this.$el.querySelector('.featured-section-v2')
    if (scrollContainer) {
      scrollContainer.removeEventListener('scroll', this.updateScrollbar)
    }
  },
  methods: {
    initScrollListener () {
      if (this._scrollListenerAttached) return
      const scrollContainer = this.$el && this.$el.querySelector('.featured-section-v2')
      if (scrollContainer) {
        scrollContainer.addEventListener('scroll', this.updateScrollbar, { passive: true })
        this._scrollListenerAttached = true
      }
    },
    goLink (e, url) {
      e.preventDefault()
      handleLinkNavigation(url)
    },
    updateScrollbar () {
      if (!this.$el) return
      const scrollContainer = this.$el.querySelector('.featured-section-v2')
      const thumb = this.$el.querySelector('.scrollbar-container__thumb')
      if (!scrollContainer || !thumb) return

      const scrollWidth = scrollContainer.scrollWidth
      const clientWidth = scrollContainer.clientWidth
      const scrollLeft = scrollContainer.scrollLeft

      // 如果內容寬度小於或等於容器寬度，代表不需要滾動，可以直接隱藏或設為滿版
      if (scrollWidth <= clientWidth) {
        thumb.style.width = '100%'
        thumb.style.left = '0%'
        return
      }

      const thumbWidth = 27 // 滑動條固定比例或寬度
      const maxScrollLeft = scrollWidth - clientWidth
      let scrollPercentage = scrollLeft / maxScrollLeft
      if (scrollPercentage < 0) scrollPercentage = 0 // 避免 ios 的 rubberband 效果
      if (scrollPercentage > 1) scrollPercentage = 1

      const maxThumbLeft = 100 - thumbWidth
      const thumbLeft = scrollPercentage * maxThumbLeft

      thumb.style.width = `${thumbWidth}%`
      thumb.style.left = `${thumbLeft}%`
    }
  }
}
</script>

<style lang="scss" scoped>
$imageWidth: 60px;
$gridRowHeight: 105px;
.featured-section-v2-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.featured-section-v2 {
  padding: 0 10px;
  min-height: 230px;
  display: grid;
  grid-template-rows: $gridRowHeight $gridRowHeight;
  grid-auto-flow: column;
  justify-items: center;
  overflow-x: auto;
  &__card {
    width: calc((100vw - 20px) / 3.5);
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  &__title {
    font-size: pxTorem(14px);
    font-weight: normal;
  }
  &__image {
    flex: 3;
    max-width: $imageWidth;
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  &__content {
    flex: 2;
    width: 100%;
    padding: 0 15px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    text-align: center;
  }
  // 隱藏 scrollbar
  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.scrollbar-container {
  position: absolute;
  bottom: 0;
  right: 50%;
  transform: translateX(50%);
  width: 17%;
  height: 8px;
  background-color: $color-background-primary;
  border-radius: 4px;
  &__thumb {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background-color: $color-primary;
    border-radius: 4px;
    transition: left 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94), width 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    will-change: left, width;
  }
}
.loading-container {
  padding: 5px 10px;
  min-height: 230px;
  display: grid;
  grid-template-rows: $gridRowHeight $gridRowHeight;
  grid-auto-flow: column;
  overflow-x: hidden;
  &__grid {
    width: calc((100vw - 20px) / 3.5);
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
  ::v-deep {
    .v-skeleton-loader {
      &__image {
        width: $imageWidth;
        height: $imageWidth;
      }
      &__card-heading {
        .v-skeleton-loader__bone {
          width: 60%;
          height: 13px;
          margin: 6px auto 0;
        }
      }
    }
  }
}
</style>
